(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component2 = __webpack_require__(2);

var _Component3 = _interopRequireDefault(_Component2);

var _FrameBuffer = __webpack_require__(8);

var _FrameBuffer2 = _interopRequireDefault(_FrameBuffer);

var _Texture2D = __webpack_require__(10);

var _Texture2D2 = _interopRequireDefault(_Texture2D);

var _Renderbuffer = __webpack_require__(9);

var _Renderbuffer2 = _interopRequireDefault(_Renderbuffer);

var _SlideComponent = __webpack_require__(1);

var _SlideComponent2 = _interopRequireDefault(_SlideComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var RenderSlideComponent = function (_Component) {
    _inherits(RenderSlideComponent, _Component);

    function RenderSlideComponent() {
        _classCallCheck(this, RenderSlideComponent);

        var _this = _possibleConstructorReturn(this, (RenderSlideComponent.__proto__ || Object.getPrototypeOf(RenderSlideComponent)).apply(this, arguments));

        _this._transiting = false;
        return _this;
    }

    _createClass(RenderSlideComponent, [{
        key: "$mount",
        value: function $mount() {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                var frame, parsed, gr;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this._gl = this.companion.get("gl");
                                this._currentBuffer = new _FrameBuffer2.default(this._gl);
                                this._lastBuffer = new _FrameBuffer2.default(this._gl);
                                this._currentTexture = new _Texture2D2.default(this._gl);
                                this._lastTexture = new _Texture2D2.default(this._gl);
                                this._renderBuffer = new _Renderbuffer2.default(this._gl);
                                this._resizeTexture(1, 1);
                                this._currentBuffer.update(this._currentTexture);
                                this._currentBuffer.update(this._renderBuffer);
                                this._lastBuffer.update(this._lastTexture);
                                this._lastBuffer.update(this._renderBuffer);
                                this._slides = this.tree("goml").single().getComponentsInChildren(_SlideComponent2.default);
                                this.getAttributeRaw("current").boundTo("_currentFrame");
                                frame = window.location.hash.substring(1);
                                parsed = void 0;

                                if (!frame && (parsed = /(\d)+\-(\d+)?/.exec(frame))) {
                                    this._currentFrame = this._toFrameIndex(parseInt(parsed[1]), parseInt(parsed[2] || 0 + ''));
                                } else {
                                    setTimeout(function () {
                                        _this2._updateHash(_this2._currentFrame);
                                    }, 0);
                                }
                                gr = this.companion.get("GeometryRegistory");
                                _context.next = 19;
                                return gr.getGeometry("quad");

                            case 19:
                                this._quad = _context.sent;

                            case 20:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    }, {
        key: "$render",
        value: function $render(args) {
            var slideInfo = this._getSlide(this._currentFrame);
            if (this._transiting && slideInfo.build === 0) {
                var progress = (Date.now() - this._transitionStartTime) / this._lastTransitionTime;
                this._renderTo(args, slideInfo.slide, this._currentBuffer);
                var lastSlide = this._getSlide(this._currentFrame - 1);
                this._renderTo(args, lastSlide.slide, this._lastBuffer);
                this._gl.bindFramebuffer(WebGLRenderingContext.FRAMEBUFFER, null);
                this._gl.clearColor(0, 0, 0, 0);
                this._gl.clear(WebGLRenderingContext.COLOR_BUFFER_BIT | WebGLRenderingContext.DEPTH_BUFFER_BIT);
                this._gl.viewport(0, 0, args.viewport.Width, args.viewport.Height);
                slideInfo.slide.transitionMaterial.setAttribute("progress", progress);
                slideInfo.slide.transitionMaterial.setAttribute("last", this._lastTexture);
                slideInfo.slide.transitionMaterial.setAttribute("current", this._currentTexture);
                slideInfo.slide.transitionMaterial.material.draw({
                    targetBuffer: "default",
                    geometry: this._quad,
                    attributeValues: {},
                    sceneDescription: {},
                    camera: null,
                    transform: null,
                    buffers: args.buffers,
                    viewport: args.viewport,
                    technique: "default"
                });
                this._gl.flush();
            } else {
                if (this._transiting) {
                    var _progress = (Date.now() - this._transitionStartTime) / this._lastTransitionTime;
                    slideInfo.slide.buildProgress(slideInfo.build, _progress);
                }
                this._renderTo(args, slideInfo.slide, null);
            }
        }
    }, {
        key: "_renderTo",
        value: function _renderTo(args, slide, fbo) {
            if (fbo) {
                this._gl.viewport(0, 0, this._bufferWidth, this._bufferHeight);
                fbo.bind();
            } else {
                this._gl.viewport(0, 0, args.viewport.Width, args.viewport.Height);
                this._gl.bindFramebuffer(WebGLRenderingContext.FRAMEBUFFER, null);
            }
            var bg = slide.backgroundColor;
            this._gl.clearColor(bg.R, bg.G, bg.B, bg.A);
            this._gl.clear(WebGLRenderingContext.COLOR_BUFFER_BIT | WebGLRenderingContext.DEPTH_BUFFER_BIT);
            slide.camera.updateContainedScene(args.timer);
            slide.camera.renderScene({
                renderer: this,
                camera: slide.camera,
                buffers: args.buffers,
                layer: "default",
                viewport: args.viewport,
                timer: args.timer,
                technique: "default",
                sceneDescription: {}
            });
        }
    }, {
        key: "$resizeBuffer",
        value: function $resizeBuffer(arg) {
            this._resizeTexture(arg.pow2Width, arg.pow2Height);
        }
    }, {
        key: "next",
        value: function next() {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
                var lastFrame, allFrame, i, currentFrameInfo;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this._transiting) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 2:
                                lastFrame = this._currentFrame;
                                allFrame = 0;

                                for (i = 0; i < this._slides.length; i++) {
                                    allFrame += this._slides[i].build;
                                }
                                this._currentFrame = Math.min(this._currentFrame + 1, allFrame - 1);
                                currentFrameInfo = this._getSlide(this._currentFrame);

                                if (!(currentFrameInfo.build === 0)) {
                                    _context2.next = 14;
                                    break;
                                }

                                _context2.next = 10;
                                return this._transitWait(currentFrameInfo.slide, currentFrameInfo.slide.transitionTime);

                            case 10:
                                if (_context2.sent) {
                                    _context2.next = 12;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 12:
                                _context2.next = 18;
                                break;

                            case 14:
                                _context2.next = 16;
                                return this._transitWait(currentFrameInfo.slide, currentFrameInfo.slide.buildTransitionTime);

                            case 16:
                                if (_context2.sent) {
                                    _context2.next = 18;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 18:
                                this._updateHash(this._currentFrame);
                                this._enterFrame(lastFrame, this._currentFrame);

                            case 20:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));
        }
    }, {
        key: "prev",
        value: function prev() {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
                var lastFrame, slideInfo, prevSlideInfo;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                lastFrame = this._currentFrame;
                                slideInfo = this._getSlide(this._currentFrame); // 前のスライドの最後までを計算

                                this._currentFrame = Math.max(this._currentFrame - 1 - slideInfo.build, 0);
                                prevSlideInfo = this._getSlide(this._currentFrame); // さらに前のスライドの最初まで戻す

                                this._currentFrame = Math.max(this._currentFrame - prevSlideInfo.build, 0);
                                this._updateHash(this._currentFrame);
                                this._enterFrame(lastFrame, this._currentFrame);
                                this._lastTransitionTime = 0;
                                this._transitionStartTime = 0;
                                this._lastWaitingHash = -1;
                                this._transiting = false;

                            case 11:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));
        }
    }, {
        key: "_resizeTexture",
        value: function _resizeTexture(width, height) {
            this._lastTexture.update(0, width, height, 0, WebGLRenderingContext.RGBA, WebGLRenderingContext.UNSIGNED_BYTE);
            this._currentTexture.update(0, width, height, 0, WebGLRenderingContext.RGBA, WebGLRenderingContext.UNSIGNED_BYTE);
            this._renderBuffer.update(WebGLRenderingContext.DEPTH_COMPONENT16, width, height);
            this._bufferWidth = width;
            this._bufferHeight = height;
        }
    }, {
        key: "_transitWait",
        value: function _transitWait(currentSlide, time) {
            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee4() {
                var hash;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this._transiting = true;
                                this._lastTransitionTime = time * 1000;
                                this._transitionStartTime = Date.now();
                                hash = this._lastWaitingHash = Math.random();
                                _context4.next = 6;
                                return this._waitFor(time * 1000);

                            case 6:
                                if (!(hash !== this._lastWaitingHash)) {
                                    _context4.next = 8;
                                    break;
                                }

                                return _context4.abrupt("return", false);

                            case 8:
                                this._lastTransitionTime = 0;
                                this._transitionStartTime = 0;
                                this._transiting = false;
                                return _context4.abrupt("return", true);

                            case 12:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));
        }
        /**
         * Call slide components events
         * @param {number} lastFrame [description]
         * @param {number} frame     [description]
         */

    }, {
        key: "_enterFrame",
        value: function _enterFrame(lastFrame, frame) {
            var lastSlide = this._getSlide(lastFrame);
            var currentSlide = this._getSlide(frame);
            lastSlide.slide.buildEnd(lastSlide.build);
            if (lastSlide.slide !== currentSlide.slide) {
                lastSlide.slide.slideEnd();
                currentSlide.slide.slideStart();
            }
            currentSlide.slide.buildStart(currentSlide.build);
        }
        /**
         * Fetch slide component and build index from index.
         * @param  {number} index [description]
         * @return {[type]}       [description]
         */

    }, {
        key: "_getSlide",
        value: function _getSlide(index) {
            var currentIndex = 0;
            for (var i = 0; i < this._slides.length; i++) {
                var slide = this._slides[i];
                if (currentIndex + slide.build > index) {
                    return {
                        slideIndex: i,
                        slide: slide,
                        build: index - currentIndex
                    };
                }
                currentIndex += slide.build;
            }
        }
    }, {
        key: "_waitFor",
        value: function _waitFor(time) {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    resolve();
                }, time);
            });
        }
    }, {
        key: "_toFrameIndex",
        value: function _toFrameIndex(slideIndex, buildIndex) {
            var sum = 0;
            for (var i = 0; i < slideIndex; i++) {
                sum += this._slides[i].build;
            }
            return sum + buildIndex;
        }
    }, {
        key: "_updateHash",
        value: function _updateHash(frame) {
            var slideInfo = this._getSlide(frame);
            if (slideInfo.slide.build === 1) {
                window.location.hash = "" + slideInfo.slideIndex;
            } else {
                window.location.hash = slideInfo.slideIndex + "-" + slideInfo.build;
            }
        }
    }]);

    return RenderSlideComponent;
}(_Component3.default);

exports.default = RenderSlideComponent;

RenderSlideComponent.attributes = {
    current: {
        default: 0,
        converter: "Number"
    }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component2 = __webpack_require__(2);

var _Component3 = _interopRequireDefault(_Component2);

var _CameraComponent = __webpack_require__(6);

var _CameraComponent2 = _interopRequireDefault(_CameraComponent);

var _MaterialComponent = __webpack_require__(7);

var _MaterialComponent2 = _interopRequireDefault(_MaterialComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SlideComponent = function (_Component) {
    _inherits(SlideComponent, _Component);

    function SlideComponent() {
        _classCallCheck(this, SlideComponent);

        return _possibleConstructorReturn(this, (SlideComponent.__proto__ || Object.getPrototypeOf(SlideComponent)).apply(this, arguments));
    }

    _createClass(SlideComponent, [{
        key: "$awake",
        value: function $awake() {
            this.build = this.getAttribute("build");
            this.transitionTime = this.getAttribute("transitionTime");
            this.buildTransitionTime = this.getAttribute("buildTransitionTime");
            this.camera = this.node.queryChildren(this.getAttribute("camera"))[0].getComponent(_CameraComponent2.default);
            this.transitionMaterial = this.tree(this.getAttribute("transition")).single().getComponent(_MaterialComponent2.default);
            this.backgroundColor = this.getAttribute("bgColor");
        }
    }, {
        key: "buildProgress",
        value: function buildProgress(buildIndex, progress) {
            var args = {
                buildIndex: buildIndex,
                progress: progress
            };
            this.node.broadcastMessage("buildProgress", args);
            this.node.emit("build-progress", args);
            console.log(buildIndex, progress);
        }
    }, {
        key: "slideStart",
        value: function slideStart() {
            this.node.broadcastMessage("slideStart");
            this.node.emit("slide-start");
        }
    }, {
        key: "slideEnd",
        value: function slideEnd() {
            this.node.broadcastMessage("slideEnd");
            this.node.emit("slide-end");
        }
    }, {
        key: "buildStart",
        value: function buildStart(build) {
            this.node.broadcastMessage("buildStart", build);
            this.node.emit("build-start", build);
        }
    }, {
        key: "buildEnd",
        value: function buildEnd(build) {
            this.node.broadcastMessage("buildEnd", build);
            this.node.emit("slide-end", build);
        }
    }]);

    return SlideComponent;
}(_Component3.default);

exports.default = SlideComponent;

SlideComponent.attributes = {
    transition: {
        default: "material#default.transition",
        converter: "String"
    },
    build: {
        default: 1,
        converter: "Number"
    },
    type: {
        default: "scene",
        converter: "String"
    },
    camera: {
        default: "camera",
        converter: "String"
    },
    transitionTime: {
        default: "0.1",
        converter: "Number"
    },
    buildTransitionTime: {
        default: "0.2",
        converter: "Number"
    },
    bgColor: {
        default: "#F9EFD5",
        converter: "Color4"
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.Node.Component;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component2 = __webpack_require__(2);

var _Component3 = _interopRequireDefault(_Component2);

var _RenderSlideComponent = __webpack_require__(0);

var _RenderSlideComponent2 = _interopRequireDefault(_RenderSlideComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SlideControllerComponent = function (_Component) {
    _inherits(SlideControllerComponent, _Component);

    function SlideControllerComponent() {
        _classCallCheck(this, SlideControllerComponent);

        return _possibleConstructorReturn(this, (SlideControllerComponent.__proto__ || Object.getPrototypeOf(SlideControllerComponent)).apply(this, arguments));
    }

    _createClass(SlideControllerComponent, [{
        key: "$mount",
        value: function $mount() {
            var canvas = this.companion.get("canvasElement");
            var slideRenderer = this.node.getComponent(_RenderSlideComponent2.default);
            canvas.addEventListener("mousedown", function () {
                slideRenderer.next();
            });
            document.addEventListener("keydown", function (e) {
                if (e.keyCode === 39) {
                    slideRenderer.next();
                }
                if (e.keyCode === 37) {
                    slideRenderer.prev();
                }
            });
        }
    }]);

    return SlideControllerComponent;
}(_Component3.default);

exports.default = SlideControllerComponent;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _grimoirejs = __webpack_require__(11);

var _grimoirejs2 = _interopRequireDefault(_grimoirejs);

var _RenderSlideComponent = __webpack_require__(0);

var _RenderSlideComponent2 = _interopRequireDefault(_RenderSlideComponent);

var _SlideComponent = __webpack_require__(1);

var _SlideComponent2 = _interopRequireDefault(_SlideComponent);

var _SlideControllerComponent = __webpack_require__(3);

var _SlideControllerComponent2 = _interopRequireDefault(_SlideControllerComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

exports.default = function () {
    _grimoirejs2.default.register(function () {
        return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _grimoirejs2.default.registerComponent("RenderSlide", _RenderSlideComponent2.default);
                            _grimoirejs2.default.registerComponent("Slide", _SlideComponent2.default);
                            _grimoirejs2.default.registerComponent("SlideController", _SlideControllerComponent2.default);
                            _grimoirejs2.default.registerNode("render-slide", ["RenderSlide"]);
                            _grimoirejs2.default.registerNode("scene-slide", ["Slide"], {}, "scene");

                        case 5:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));
    });
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RenderSlideComponent = __webpack_require__(0);

var _RenderSlideComponent2 = _interopRequireDefault(_RenderSlideComponent);

var _SlideComponent = __webpack_require__(1);

var _SlideComponent2 = _interopRequireDefault(_SlideComponent);

var _SlideControllerComponent = __webpack_require__(3);

var _SlideControllerComponent2 = _interopRequireDefault(_SlideControllerComponent);

var _main = __webpack_require__(4);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __VERSION__ = "0.0.4";
var __NAME__ = "grimoirejs-slide-system";

var __EXPOSE__ = {
    "Components": {
        "RenderSlideComponent": _RenderSlideComponent2.default,
        "SlideComponent": _SlideComponent2.default,
        "SlideControllerComponent": _SlideControllerComponent2.default
    }
};
var __BASE__ = (0, _main2.default)();
Object.assign(__EXPOSE__, {
    __VERSION__: __VERSION__,
    __NAME__: __NAME__
});
Object.assign(__BASE__ || {}, __EXPOSE__);
window["GrimoireJS"].lib.slide_system = __EXPOSE__;
exports.default = __BASE__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Components.CameraComponent;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Components.MaterialComponent;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Resource.FrameBuffer;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Resource.RenderBuffer;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Resource.Texture2D;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS;

/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-slide-system/register/index.js
// module id = 5
// module chunks = 0